import type { ProductModuleId } from '@config/products/productModules';

import { isModuleLocked } from '@config/products/productGating';

import { useCurrentServicesProvider } from './useCurrentServicesProvider';

interface ProductAccessResult {
	/** Whether the provider has an active subscription for this product */
	hasAccess: boolean;
	/** Whether the provider data is still loading */
	isLoading: boolean;
}

/**
 * Generic hook to check whether the current services provider
 * has access to a given product module.
 *
 * Usage:
 *   const { hasAccess, isLoading } = useProductAccess('aiBdc');
 */
export function useProductAccess(moduleId: ProductModuleId): ProductAccessResult {
	const { data: provider, isLoading } = useCurrentServicesProvider();

	if (isLoading || !provider) {
		return { hasAccess: false, isLoading };
	}

	return { hasAccess: !isModuleLocked(provider, moduleId), isLoading: false };
}
